import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import { MetricTable, selectFormat, Error } from "./../Utils/Utils.js";

const metric = (cell, row, enumObject, params) => {
  const props = { ...cell, ...params };
  return <MetricTable {...props} />;
};

class ConnectorsMetrics extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      hiddenRows: [],
      expandedRows: false,
      currentRowID: null,
    };
  }

  componentDidMount() {
    this.props.childRef(this);
    this.setState({
      hiddenRows: this.props.data.rows
        .filter((d) => d.tenant_name === "")
        .map((row) => row.id),
    });
  }

  renderTable = (data) => {
    const { cells, title, url } = this.props;

    data.forEach((d, i) => (d.id = i));

    const showRows = (row) => {
      // Show specific rows
      let indexesToShow = [];

      for (let i = row.id + 1; i <= data.length - 1; i++) {
        if (data[i].tenant_name === "") {
          indexesToShow.push(i);
        } else {
          break;
        }
      }

      this.setState({
        hiddenRows: data
          .filter((d) => d.tenant_name === "")
          .map((row) => row.id)
          .filter((x) => !indexesToShow.includes(x)),
        expandedRows: true,
        currentRowID: row.id,
      });
    };

    const hideRows = (row) =>
      this.setState({
        hiddenRows: this.props.data.rows
          .filter((d) => d.tenant_name === "")
          .map((row) => row.id),
        expandedRows: false,
        currentRowID: row.id,
      });

    const toggleRows = (row) => {
      this.setState({
        currentRowID: row.id,
      });

      if (
        row.id === this.state.currentRowID ||
        this.state.currentRowID === null
      ) {
        if (this.state.expandedRows) {
          hideRows(row);
        } else {
          showRows(row);
        }
      } else {
        if (this.state.expandedRows) {
          hideRows(row);
          showRows(row);
        } else {
          showRows(row);
        }
      }
    };

    const columns = [
      {
        dataField: "tenant_name",
        text: "Tenant Name",
        style: {
          width: "100px",
          minWidth: "100px",
          textAlign: "left",
        },
        headerAlign: "left",
        formatExtraData: {
          tenant_name: url.split("/")[2],
        },
        csvFormatter: (cell, row) => row && (row.tenant_name || ""),
        formatter: (cellContent, row) => {
          if (row.connector === "Total") {
            return (
              <button
                onClick={() => toggleRows(row)}
                className="toggleRowButton"
              >
                <span>{row.tenant_name} ↓</span>
              </button>
            );
          }
        },
      },
      {
        dataField: "connector",
        text: "Connector",
        style: { width: "80px", minWidth: "80px", verticalAlign: "top" },
        csvFormatter: (cell, row) => row && row.platform,
      },
      {
        dataField: "events",
        text: "Events",
        style: { width: "90px", minWidth: "90px", verticalAlign: "top" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
      },
      {
        dataField: "bytes",
        text: "Bytes",
        style: { width: "90px", minWidth: "90px", verticalAlign: "top" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) =>
        selected_columns.push(columns.find((o) => o.dataField === cell))
      );
    }
    const filename = title.split(" ").join("_") || "spreadsheet";

    const rowStyle = (row) => {
      const style = {};
      if (row.connector === "Total") {
        style.backgroundColor = "#eee";
      }

      return style;
    };

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            rowStyle={rowStyle}
            hiddenRows={this.state.hiddenRows}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  };

  builtInExportCSV = () => this.childRef;

  render() {
    const data = this.props.data.rows;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data);
  }
}

export default ConnectorsMetrics;
